import { render, staticRenderFns } from "./wuYeManagement.vue?vue&type=template&id=583e3f74&scoped=true&"
import script from "./wuYeManagement.vue?vue&type=script&lang=js&"
export * from "./wuYeManagement.vue?vue&type=script&lang=js&"
import style0 from "./wuYeManagement.vue?vue&type=style&index=0&id=583e3f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583e3f74",
  null
  
)

export default component.exports